import React from 'react';
import useBodyClassName from 'hooks/useBodyClassName';
import { LoadingMask } from 'components/core/LoadingMask';

import './Loading.scss';

export default function LoadingPage() {
	useBodyClassName('no-scroll no-footer');
	return (
		<div className="page-loading">
			<LoadingMask />
		</div>
	);
}
